import { runtime } from "std-env";
import { z } from "zod";
const envSchema = z.object({
    ENV: z.union([z.literal("development"), z.literal("production")]),
    PORT: z.coerce.number(),
    AWARDS_LIST_BUCKET_NAME: z.string(),
    AWARDS_LIST_OBJECT_KEY: z.string(),
    EMAIL_QUEUE_URL: z.string(),
    SMS_QUEUE_URL: z.string(),
    USER_POOL_ID: z.string(),
    USER_POOL_CLIENT_ID: z.string(),
    AWS_ACCESS_KEY_ID: z.string().optional(),
    AWS_SECRET_ACCESS_KEY: z.string().optional(),
});
export let env;
if (runtime === "node") {
    env = envSchema.parse(process.env);
    // env = {
    //   ENV: process.env.ENV ?? "development",
    //   PORT: parseInt(process.env.PORT ?? "3333"),
    //   AWARDS_LIST_BUCKET_NAME: process.env.AWARDS_LIST_BUCKET_NAME ?? "",
    //   AWARDS_LIST_OBJECT_KEY: process.env.AWARDS_LIST_OBJECT_KEY ?? "",
    //   EMAIL_QUEUE_URL: process.env.EMAIL_QUEUE_URL ?? "",
    //   USER_POOL_ID: process.env.USER_POOL_ID ?? "",
    //   AWS_ACCESS_KEY_ID: process.env.AWS_ACCESS_KEY_ID,
    //   AWS_SECRET_ACCESS_KEY: process.env.AWS_SECRET_ACCESS_KEY,
    // };
}
export function setEnv(e) {
    env = envSchema.parse(e);
}
//# sourceMappingURL=env.js.map